<template>
  <button
      type="button"
      class="download-button"
      :disabled="loading"
      @click="$emit('click')">
    <span
        v-if="loading"
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"></span>

    <i v-else
        class="fa-solid fa-download me-2"
        aria-hidden="true"></i>

    <span>
      {{ loading ? $t('general.button.generating_document') : label }}
    </span>
  </button>
</template>

<script setup>
import {defineProps, defineEmits, computed} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)

const companyColor = computed(() => companySettings.value?.colorCode || '#15803d')

const companyBgColor = computed(() => companySettings.value?.colorCode
    ? `${companySettings.value.colorCode}15`
    : '#ecfdf5'
)

defineProps({
  label: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])

</script>

<style scoped>
.download-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  border: 1px solid v-bind(companyColor);
  color: v-bind(companyColor);
  background-color: v-bind(companyBgColor);

  padding: 6px 14px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.download-button:hover:not(:disabled) {
  filter: brightness(0.96);
  transform: translateY(-1px);
}

.download-button:active:not(:disabled) {
  transform: translateY(0);
}

.download-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.download-icon {
  font-size: 14px;
}

.download-spinner {
  width: 15px;
  height: 15px;
  border-width: 2px;
}

.download-button-text {
  white-space: nowrap;
}

@media (max-width: 640px) {
  .download-button {
    width: 100%;
    justify-content: center;
    margin-bottom: 10px;
    margin-top: 20px;
    margin-right: 0;
  }
}
</style>